import React, { createContext, useContext, useState } from "react";
import { MESSAGE, SETTING } from "../constant";

interface WidgetContextProviderProps {
    children: React.ReactNode
}

type contextValueType = {
    appLoading: boolean
    slippage: number
    setSlippage: (slippage: number) => void
    setAppLoading: (appLoading: boolean) => void
}

const WidgetContext = createContext<contextValueType>({
    appLoading: false,
    slippage: SETTING.SWAP_SETTING.DEFAULT_SLIPPAGE,
    setSlippage: () => {},
    setAppLoading: () => {}
})

const WidgetProvider = (props: WidgetContextProviderProps) => {

    const [slippage, setSlippage] = useState<number>(SETTING.SWAP_SETTING.DEFAULT_SLIPPAGE)
    const [appLoading, setAppLoading] = useState<boolean>(false)

    const contextValue: contextValueType = {
        appLoading,
        slippage,
        setSlippage,
        setAppLoading
    }
    return (
        <WidgetContext.Provider value={contextValue}>
            { props.children }
        </WidgetContext.Provider>
    )
}

export const useWidget = () => {
    const context = useContext(WidgetContext)

    if(context === undefined) {
        throw new Error(MESSAGE.ERROR.CONTEXT)
    }

    return context
}


export default WidgetProvider